import { ComponentInstance, onBeforeMount } from "@vue/composition-api";

const useGetTableLibs = (root: ComponentInstance): void => {
  const store = root.$store;
  const isOpenModalOnStart = !!root.$route.query.isOpenModal;

  onBeforeMount(() => {
    store.dispatch("archiveCatalogView/getFundList");
    store.dispatch("archiveCatalogView/getViewMode", isOpenModalOnStart);
  });
};

export default useGetTableLibs;
